// src/hooks/programs/useCreateProgram.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createProgram } from "../../api/apiPrograms";
import parseError, { parseResponseMsg } from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreateProgram = (onSuccessCallback) => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createProgramMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createProgram,
        onSuccess: (response) => {
            const message = parseResponseMsg(response?.message || response, "تم إنشاء البرنامج بنجاح");
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
            if (onSuccessCallback) {
                onSuccessCallback(response);
            } else {
                navigate('/programs');
            }
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        },
    });

    return {
        createProgramMutate,
        isPending: isPending || isLoading,
    };
};

export default useCreateProgram;
